import { useQuery } from '@tanstack/react-query';

import { notesSettingsOptions } from '@/entities/practice-member-settings';
import {
    treatmentApproachesGroups,
    treatmentApproachesOptions,
} from '@/entities/treatment-approach';

export function useTreatmentApproachesOptions() {
    const { data } = useQuery(notesSettingsOptions());

    if (!data) return treatmentApproachesOptions;

    return treatmentApproachesOptions.map((option) => ({
        ...option,
        group: data.value.treatmentApproaches.includes(option.value)
            ? treatmentApproachesGroups.your
            : treatmentApproachesGroups.others,
    }));
}
